import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import { getInsightListPaged, getInsightListTotal,generateThumbnails, removethisItem, getTotal } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import Pagination from "react-js-pagination";


class cmsInsights extends Component {

    constructor(props) {
        super(props);
        var url = new URL(window.location.href);
        var location = url.searchParams.get("location");
        var auth_data = JSON.parse(localStorage.getItem("user_data"));
        this.state = {
              logged: localStorage.getItem("authentication"),
              auth_data: JSON.parse(localStorage.getItem("user_data")),
              location: '',
              mailList: [],
              searchby:'',
              activePage:0,
              tablename : 'bw_insight_content',
              PER_PAGE:15,
              offset:0,
              total:0,
              loading:true
        };

        this.getList();
    }


    componentDidMount() {
  

        var THIS = this;
        $(document).on('click', '.remove_insight', function () {
          var delete_id = $(this).data("id");
           
           if(confirm("You are sure to delete?")==true){

            let ins = JSON.stringify({
              id: delete_id,
              table:'insight'
            });

            removethisItem(ins).then((res) => {

                THIS.getTotal(); 
                THIS.getList();

            });

            }

        });

        this.getTotal();
        this.getList();


    }


    getTotal = (location='') => {


      const locationselected = (location=='')?this.state.location:location;

      let ins = JSON.stringify({
        vertical: this.state.tablename,
        location: locationselected,
        searchby:this.state.searchby,
      });

      getTotal(ins).then((res) => {


        this.setState({loading:true});

        if (res.status == 1) {

                  
          this.setState({
            
            total: res.total
            
          });

        } 
      });
    }  

    generateThumbnails = () => {

      generateThumbnails().then((res) => {

        if (res.status == 1) {
          alert("All generated");
        } 
        else{
          console.log(res.message);
        }
      });

    }  

    

    getList = (pageNumber=1, location='') => {

      const { login_id, role } = this.state.auth_data;
      
      this.setState({activePage: pageNumber});

      const newOffset = (pageNumber==1)? 0 : (((pageNumber-1) * this.state.PER_PAGE)%this.state.total);

      const locationselected = (location=='')?this.state.location:location;

      let ins = JSON.stringify({
        vendor_id: login_id,
        role: role,
        location: locationselected,
        searchby:this.state.searchby,
        perpage:this.state.PER_PAGE,
        offset:newOffset
      });

      getInsightListPaged(ins).then((res) => {


        this.setState({loading:true});

        if (res.status == 1) {

          this.setState({loading:!this.state.loading});
          
          this.setState({
            
            mailList: res.data
            
          });

        } else {

          this.setState({loading:!this.state.loading});
          
          this.setState({
            mailList: [],
          });
        }
      });


    }    


    handleSelect = (e) => {
        this.setState({ location: e.target.value, activePage:1});
        this.getTotal(e.target.value);
        this.getList(1, e.target.value);
    };

 
    handleChange = (e) => {
      this.setState({ [e.target.name]: e.target.value });
    };

    handlePageChange(pageNumber) {
        this.setState({activePage: pageNumber});
        this.getList(pageNumber);
    }

    searchBy = (e) => {
        
      this.setState({loading:true, activePage:1});
      this.getTotal();
      this.getList(1); 

    };

    render() {


        const { mailList, currentPage, PER_PAGE, total, exportbtndisabled } = this.state;

        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Articles</h4>
                 
                  { /* <div class="float-right">
                    <div onClick={this.generateThumbnails} class="btn btn-primary btn-sm">Generate WEBP images</div>&nbsp;
                  </div> */} 
                  <div class="float-right"><a href="/cms/insights/addinsight" class="btn btn-primary btn-sm">Add New</a></div>
                 
                  <p class="card-description">
                    <div class="cityselection">
                      <div class="leftaligned bwlabel">City</div>
                      <div class="leftaligned"><select name="location" class="form-control" onChange={(e) => this.handleSelect(e)}
                                                       value={this.state.location}>
                                                      <option value="">select city</option>
                                                      <option value="1">Bengaluru</option>
                                                      <option value="12">Chennai</option>
                                                      <option value="27">Hosur</option>
                                              </select>
                      </div>

                      <div class="leftaligned bwlabel">Search</div>
                      <div class="leftaligned"><input type="text" name="searchby" class="form-control form-control-sm" onChange={this.handleChange} /></div>
                      <div class="leftaligned"><button class="btn btn-primary btn-sm" onClick={this.searchBy}>Go</button></div>
                    </div>
                  </p>

                  <div class="table-responsive pt-3">
                     <table id="tablebw">
                      <thead class="thead-dark">
                        <tr>
                          <th>
                            <strong>S.No</strong>
                          </th>
                          <th>
                            <strong>Blog Title</strong>
                          </th>

                          <th>
                            <strong>Category</strong>
                          </th>

                          <th>
                            <strong>Blog For/From</strong>
                          </th>

                          <th>
                            <strong>Date</strong>
                          </th>
                         
                          <th>
                            <strong>Author</strong>
                          </th>
                                                 
                          <th>
                            <strong>Status</strong>
                          </th>
                           <th>
                            <strong>Action</strong>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                      {mailList.map((item, i) => {     
                      
                       return <tr>
                          <td>
                          {item.s_no}
                          </td>
                          <td>
                           {item.title}
                          </td>
                          <td>
                           {(item.category_name==0)?"None":item.category_name}
                          </td>
                          <td>
                            {item.blogfor}
                          </td>
                          <td>
                           {item.updated_date}
                          </td>
                          <td>
                            {item.author}
                          </td>
                          <td dangerouslySetInnerHTML={{__html: item.status}} />  
                          <td dangerouslySetInnerHTML={{__html: item.action}} />
                        </tr>

                      })

                      }
                       
                      </tbody>
                    </table>

                     <div class="text-center">
                      
                      <Pagination
                        activePage={this.state.activePage}
                        itemsCountPerPage={PER_PAGE}
                        totalItemsCount={this.state.total}
                        pageRangeDisplayed={5}
                        activeClass={"pagination__link--active"}
                        onChange={this.handlePageChange.bind(this)}
                        prevPageText="previous"
                        nextPageText="next"
                      />

                    </div>


                  </div>
                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default cmsInsights;


// WEBPACK FOOTER //
// ./src/components/bewise/cmsInsights.jsx